<template>
  <v-app-bar color="primary" dark app elevate-on-scroll style="z-index: 99">
    <v-app-bar-nav-icon class="d-flex d-md-none" @click="handleDrawerToggle" />
    <div style="margin-top: 13px" class="d-none d-md-flex">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <v-spacer />
    <v-toolbar-items>
      <el-button
        small
        tile
        color="primary"
        icon="akiniai"
        @click.native="changeForAccessibility"
        title=""
      />
      <el-button @click.native="openHelp" small tile color="primary" icon="pagalba">
        <!-- user help -->
        <v-row v-if="userHelp" class="user-help-card">
            <v-col class="pb-0 pt-1" cols="12">Naudotojo vadovas:</v-col>
            <v-col class="pb-0 pt-1" cols="12"><v-divider class="white"></v-divider></v-col>
            <v-col v-if="showHelpAdmin" class="pb-0 pt-1" cols="12"><a class="help-item-link" @click="getHelp('manual_admin')">Administratorius</a></v-col>
            <v-col v-if="showHelpRegistrator" class="pb-0 pt-1" cols="12"><a class="help-item-link" @click="getHelp('manual_registrator')">Registratorius</a></v-col>
            <v-col v-if="showHelpKAC" class="pb-0 pt-1" cols="12"><a class="help-item-link" @click="getHelp('manual_kac')">KAC darbuotojo</a></v-col>
            <v-col v-if="showHelpVasu" class="pb-2 pt-1" cols="12"><a class="help-item-link" @click="getHelp('manual_vasu')">Sutartinio naudotojo</a></v-col>
        </v-row>
      </el-button>
      <el-button @click.native="openUserInfo" small tile color="primary" icon="">
        <span class="toolbar-user">{{ $t('Prisijungęs') }}</span>
        <strong>{{ getTextForUsername }}</strong>
        <!-- user info -->
        <v-row v-if="userInfo" class="user-info-card">
            <v-col class="pb-0 pt-1" cols="12">{{ getTextForPosition }}</v-col>
            <v-col class="pb-0 pt-1" cols="12"><strong>{{ getTextForUsername }}</strong></v-col>
            <v-col class="pt-1" cols="12"><small>{{ getTextForCompany }}</small></v-col>
        </v-row>
      </el-button>
      <el-button
        small
        tile
        color="primary"
        icon="atsijungti"
        @click.native="handleLogut"
        title="Atsijungti"
      />
    
    </v-toolbar-items>
  
    <modal-profile v-model="showProfile" />
  </v-app-bar>
</template>
<script>
import Roles from '@/components/constants/roles'
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import ModalProfile from '@/components/modals/ModalProfile'
import AppBreadcrumbs from '@/layouts/ireg/AppBreadcrumbs'
import math from '../../mixins/math'

export default {
  name: 'AppToolbar',
  components: {
    ModalProfile,
    AppBreadcrumbs,
  },
  mixins: [userRole, math],
  data() {
    return {
      userInfo: false,
      userHelp: false,
      profileMenus: [
        {
          icon: 'mdi-account',
          href: '',
          title: 'Profilis',
          click: this.handleProfile,
        },
        {
          icon: 'mdi-power',
          href: '',
          title: 'Atsijungti',
          click: this.handleLogut,
        },
      ],
      showProfile: false,
      langs: ['lt', 'en'],
    }
  },
  computed: {
    ...mapGetters(['getAvatar', 'getUsername', 'getUserPosition', 'getUserCompany', 'userID', 'getForAccessibility']),
    showHelpAdmin() {
      return this.hasRole([Roles.IR_ADMINISTRATORIUS])
    },
    showHelpRegistrator() {
      return this.hasRole([Roles.IR_REGISTRATORIUS])
    },
    showHelpKAC() {
      return  this.hasRole([Roles.IR_KAC_DARBUOTOJAS, Roles.IR_RC_darbuotojas])
    },
    showHelpVasu() {
      return this.hasRole([
        Roles.IR_issami, Roles.IR_issami_su_turiniu, Roles.IR_santrauka, Roles.IR_kitos, Roles.IR_paslauga, Roles.IR_archyvas, Roles.IR_archyvas_kitos, 
        Roles.NOTARAS, Roles.KONSULAS, Roles.TEISMAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2               
      ])
    },
    computeLogoIcon() {
      return '/static/turtas_icon_color.png'
    },
    getTextForPosition() {
      return this.getUserPosition
    },
    getTextForCompany() {
      return this.getUserCompany
    },
    getTextForUsername() {
      return this.getUsername
    },

    availableLanguages() {
      const { locales } = this.$vuetify.lang
      return Object.keys(locales).map((lang) => {
        return {
          text: locales[lang].label,
          value: lang,
        }
      })
    },
    localeText() {
      const find = this.availableLanguages.find(
        (item) => item.value === this.$vuetify.lang.current
      )
      return find.text
    },
    appMark() {
      if (process.env.VUE_APP_LOCAL === 'develop') {
        if (process.env.VUE_APP_PREPROD === 'true') {
          return '/static/preprod-mark.png'
        }
        return '/static/dev-mark.png'
      }
      if (process.env.VUE_APP_LOCAL === 'test') {
        return '/static/test-mark.png'
      }
      return null
    },
  },
  methods: {
     changeForAccessibility(){
      location.reload()
      this.$store.dispatch('changeForAccessibility', !this.getForAccessibility)
    },
     hasRole(roles) {
      const userRole = this.$store.getters.userRole
      return roles.some((item) => {
        return userRole.includes(item)
      })
    },
    handleDrawerToggle(){
      this.$root.$emit('drawerToggle') 
    },
    openUserInfo(){
      this.userHelp && (this.userHelp = !this.userHelp)
      this.userInfo = !this.userInfo
    },
    openHelp(){
      this.userInfo && (this.userInfo = !this.userInfo)
      this.userHelp = !this.userHelp
    },
    changeLang() {
      if (this.$i18n.locale === 'lt') {
        this.$store.dispatch('changeLanguage', { lang: 'en', i18n: this.$i18n })
      } else {
        this.$store.dispatch('changeLanguage', { lang: 'lt', i18n: this.$i18n })
      }
    },
    handleLogut() {
      // if (window.confirm('Ar norite atsijungti?')) {
      this.$store.dispatch('logout').then(() => {
        this.$root.$emit('SHOW_SNACKBAR', {
          text: this.$t('Atsijungta sėkmingai'),
          color: 'success',
        })
        this.$router.push({ name: 'login' })
      })
      // }
    },
    getHelp(name) {
      let formData = { type: name }
      this.$axios
        .post(`download-manual`, formData)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    handleChangeLocale({ value }) {
      this.$vuetify.lang.current = value
    },
    handleSetting() {},
    handleProfile() {
      this.showProfile = true
    },
    handleGoBack() {
      this.$router.go(-1)
    },
    gotoHome() {
      this.$router.push({ name: 'home' })
    },
  },
  created() {},
}
</script>

<style lang="scss" scoped>
.top-logo,
.app-title {
  cursor: pointer;
}
.top-logo {
  margin-left: 0px;
}
.user-help-card{
    position: absolute;
    top: 37px;
    border-top: 1px solid powderblue;
    background-color: #198677b6;
    white-space: normal;
    width: 13rem;
    animation-name: openInfo;
    animation-duration: .6s;
}
.user-info-card{
    position: absolute;
    top: 36px;
    border-top: 1px solid powderblue;
    background-color: #198677b6;
    white-space: normal;
    width: 150%;
    animation-name: openInfo;
    animation-duration: .6s;
}
@keyframes openInfo {
  0%   {background-color: transparent; }
  100% {background-color:#198677b6; }
}
.help-item-link{
  &:hover{
    color: rgba(245, 245, 245, 0.664);
  }
  color:white
}
</style>
